import React from "react";
// import "../css/qualification.css"
import QualificationEducations from "../components/QualificationEducations";
import QualificationExperiences from "../components/QualificationExperiences";
import { useState } from "react";

const Qualification = () => {
  const [change, setChange] = useState(true);
  const content = change ? (
    <QualificationExperiences />
  ) : (
    <QualificationEducations />
  );

  return (
    <section className="qualification" id="qualification">
      <h1 className="text-center mb-4">Qualification</h1>
      <nav class="btns-container">
        <button
          className={change ? "active" : ""}
          onClick={() => setChange(true)}
        >
          Experience
        </button>
        <button
          className={!change ? "active" : ""}
          onClick={() => setChange(false)}
        >
          Education
        </button>
      </nav>
      {content}
    </section>
  );
};

export default Qualification;
